<template>
  <div>
    <v-layout row wrap>
      <v-flex >

      </v-flex>
      <v-flex xs10 sm10 offset-sm1>
        <p class="notify">
        To be able to login to your Rovers account, you will need to have re-registered since <strong>November 2023</strong>. 
      For instructions on how to re-register, please <a target="_blank" href="https://www.rovers.co.uk/tickets/information/my-rovers/">click here</a>. 
      </p>
    </v-flex>
      <v-flex ></v-flex>
    </v-layout>
    <v-container grid-md>
      <v-layout style="display: flex; flex-wrap: wrap">
        <v-flex d-flex class="login-box">
          <main v-if="loggedIn === false">
            <PageIntro
              :heading="'Aleady have a ' + configStrings.productName + '?'"
              :body="
                '<p>Sign in with your ' +
                configStrings.productName +
                ' below.</p>'
              "
            />

            <v-container
              fluid
              grid-list-lg
              class="login-container"
              v-if="paramsValid === true"
            >
            <v-alert
            :value="true"
            v-if="error != null"
            type="error"
            v-html="error.message"
          ></v-alert>
          <v-alert :value="true" v-if="success != null" type="success">{{
            success.message
          }}</v-alert>
              <v-layout row wrap>
                <v-flex xs12 sm10 offset-sm1>
                  <v-layout align-center justify-center column pb-2>
                    <h2 class="heading-3">Sign in with email</h2>
                  </v-layout>
                  <v-layout justify-center column>
                    <v-form ref="form" v-model="valid" @submit="login">
                      <v-text-field
                        outline
                        v-model="username"
                        :rules="usernameRules"
                        label="Email *"
                        type="email"
                        required
                      ></v-text-field>

                      <v-text-field
                        outline
                        v-model="pass"
                        :rules="passRules"
                        label="Password *"
                        type="password"
                        required
                      ></v-text-field>

                      <v-layout row align-center mx-1>
                        Need an account?&nbsp;<router-link
                          to="/oauth2/signup"
                          class="text-button"
                          >Sign up</router-link
                        >
                        <v-spacer />
                        <button type="submit" :disabled="!valid" class="button">
                          Login
                        </button>
                      </v-layout>
                      <v-layout row align-center mx-1>
                        Forgotten password?&nbsp;<router-link
                          to="/forgot-password"
                          class="text-button"
                        >
                          Send a password reminder</router-link
                        >
                        <v-spacer />
                      </v-layout>
                    </v-form>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </main>
        </v-flex>
        <v-flex d-flex class="home-box">
          <div>
            <!-- <PageIntro 
              :heading="'Don\'t have a digital membership yet?'"
              :body="'<p>Register now and become #PartOfThePride!</p>'+
              '<p>Here\'s some of what you get:</p>'+
              '<ul><li>Watch Pre & post-match news and highlights on {{configStrings.clubStreamingPlatformName}}.</li>'+
              '<li>Listen to live match commentary.</li>'+
              '<li>Exclusive UZ competitions and polls.</li>'+
              '<li>Personalise your digital experience with the Club.</li>'+
              '<li>Access to the Pride Rewards loyalty scheme</li>'+
              '<li>Manage your ticketing account</li></ul></p>'"/> -->
            <PageIntro
              :heading="'Don\'t have a ' + configStrings.productName + ' yet?'"
              :body="
                '<p>Register now and for access to exclusive ' +
                configStrings.clubName +
                ' content and benefits.</p>'
              "
            />
            <HomeRegister />
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import PageIntro from "@/components/PageIntro";
import HomeRegister from "@/components/HomeRegister";
import axios from "axios";
import qs from "qs";
//import base64url from "base64url";
import crypto from "crypto";

export default {
  components: {
    PageIntro,
    HomeRegister,
  },
  data() {
    return {
      passRules: [
        (v) => !!v || "Password is required",
        (v) =>
          (v && v.length >= 8) ||
          "Remember, your password will have been at least 8 characters.",
      ],
      usernameRules: [
        (v) => !!v || "Email address is required",
        (v) => /.+@.+/.test(v) || "Email must be valid",
        (v) =>
          !v.includes(" ") || "An email address can not contain any spaces",
      ],
      username: "",
      pass: "",
      hashedPassword: "",
      key: process.env.VUE_APP_GC_AUTH_KEY,
      iv: process.env.VUE_APP_GC_AUTH_IV,
      error: null,
      loggedIn: false, //assume they are logged in
      valid: true,
      paramsValid: true,
      loading: false,
      success: null,
      qsParams: {},
      cookieName: "",
    };
  },
  mounted() {
    this.qsParams = qs.parse(window.location.search.substring(1));
    console.log("qs", this.qsParams);

    if (
      (!this.qsParams["client_id"] ||
        !this.qsParams["response_type"] ||
        !this.qsParams["redirect_uri"] ||
        !this.qsParams["scope"]) &&
      (!localStorage.oauthClientId ||
        !localStorage.oauthResponseType ||
        !localStorage.oauthRedirectUri ||
        !localStorage.oauthScope)
    ) {
      this.paramsValid = false;
    } else {
      if (this.qsParams["client_id"]) {
        // if we detect it is coming from a URL request, write into local storage with the parameter values
        localStorage.oauthClientId = this.qsParams["client_id"];
        localStorage.oauthResponseType = this.qsParams["response_type"];
        localStorage.oauthRedirectUri = this.qsParams["redirect_uri"];
        localStorage.oauthScope = this.qsParams["scope"];
        localStorage.oauthState = this.qsParams["state"];
        localStorage.oauthNonce = this.qsParams["nonce"];
      }
      localStorage.loginFlow = "oauth2";
    }


    console.log("valid?", this.paramsValid);

    if (this.paramsValid === false) {
      this.error = { message: "Invalid parameters passed by partner platform" };
    } else {
      console.log("All parameters passed");
    }
  },
  methods: {
    async login(e) {
      e.preventDefault();
      let cipher = crypto.createCipheriv('aes-256-cbc', this.key, this.iv);
      let encrypted = cipher.update(this.pass, 'utf8', 'base64');
      encrypted += cipher.final('base64');
      this.hashedPassword = encrypted
      
      var data = JSON.stringify({
        client_id: localStorage.oauthClientId,
        client_secret: localStorage.oauthClientSecret,
        response_type: localStorage.oauthResponseType,
        redirect_uri: localStorage.oauthRedirectUri,
        state: localStorage.oauthState,
        nonce: localStorage.oauthNonce,
        scope: localStorage.oauthScope,
        username: this.username,
        ciptoken: this.hashedPassword,
      });

      var config = {
        method: "post",
        url: process.env.VUE_APP_GC_AUTH_ENDPOINT,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      this.loading = true;

      //console.log(config)

      var vm = this;
      axios(config)
        .then(function (response) {
          console.log("making request for code");
          //console.log(JSON.stringify(response.data));
          //console.log("AUTH CODE", response.data.code);
          if (typeof response.data.code == "undefined") {
            vm.loading = false;
            vm.error = {
              message: "Unable to login, please check your email and password.",
            };
          } else {
            vm.loading = false;

            var oauthRedirectUri = localStorage.oauthRedirectUri;
            var oauthState = localStorage.oauthState;

            localStorage.removeItem("oauthClientId");
            localStorage.removeItem("oauthClientSecret");
            localStorage.removeItem("oauthResponseType");
            localStorage.removeItem("oauthRedirectUri");
            localStorage.removeItem("oauthScope");
            localStorage.removeItem("oauthState");
            localStorage.removeItem("oauthNonce");
            localStorage.removeItem("loginFlow");
            window.location.replace(
              oauthRedirectUri +
                "?code=" +
                response.data.code +
                "&state=" +
                oauthState
            );
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.loading = false;
          vm.error = {
            message: "There was an error whilst retrieving authorisation",
          };
        });
    },
    signUpSelected() {
      alert("signing up");
    },
    getCookieValue(cookieName) {
      const cookies = document.cookie.split(";");
      for (const cookie of cookies) {
        const [name, value] = cookie.trim().split("=");
        if (name === cookieName) {
          return decodeURIComponent(value);
        }
      }
      return null; // Return null if the cookie with the specified name is not found
    },
  },
};
</script>
<style scoped>
.notify {
  text-align: center;
  border: 3px solid red;
  padding: 10px;
  max-width: 1300px;
}
</style>